var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "pager-wrap", class: _vm.paginationConf.className },
    [
      _vm.pages > 1
        ? _c("ul", { staticClass: "pager" }, [
            _vm.paginationConf.currentNo > 1
              ? _c("li", [
                  _c("a", {
                    staticClass: "fa fa-caret-left",
                    staticStyle: { "padding-right": "20px" },
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function($event) {
                        return _vm.prevPage()
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                staticStyle: { "padding-left": "10px", "padding-right": "10px" }
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.currentNo) + " / " + _vm._s(_vm.pages) + " "
                )
              ]
            ),
            _vm._v(" "),
            _vm.currentNo < _vm.pages
              ? _c("li", [
                  _c("a", {
                    staticClass: "fa fa-caret-right",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function($event) {
                        return _vm.nextPage()
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.gopage,
                    expression: "gopage"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", "data-role": "gopage" },
                domProps: { value: _vm.gopage },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.gopage = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0);" },
                  on: {
                    click: function($event) {
                      return _vm.go()
                    }
                  }
                },
                [_vm._v("跳转")]
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }